import './App.css';

function App() {
  return (
    <div id="page-top">
      <div id="apDiv2">
        <a href="#myModal">
           
          </a>
      </div>

      <div id="apDiv4">
        <div className="apDiv4-call" data-toggle="modal" data-target="#myModals">
          <i className="fa fa-car faa-tada animated"></i>&ensp;&ensp;Site Visit
        </div>
      </div>
      <div id="apDiv5">
        <div className="apDiv5-call"><a href="tel:+919130568016">
          <i className="fa fa-phone faa-tada animated"></i>&ensp;+91 9130568016</a>
        </div>
      </div>


      <div id="myModal" className="modal fade" role="dialog">
         <div className="modal-dialog">
            <div className="modal-content">
               <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal">&times;</button>
                  <h4 className="modal-title pop_align">Kalpataru Parkcity Thane Brochure</h4>
               </div>
               <div className="modal-body">
                  <form action="maildownload.php" method="post">
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-user"></i></span>
                           <input className="form-control" name="fname" id="fnames" placeholder="Name" required />
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                           <input type="email" className="form-control" name="email" id="emails" placeholder="Email" required />
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-phone-square" ></i></span>
                           <input type="text" className="form-control" name="mobile" id="mobiles" placeholder="Mobile" required />
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-comment"></i></span>
                           <textarea className="form-control" name="mesg" id="mesgs" placeholder="Massage" rows="3"></textarea>
                        </div>
                     </div>
                     <div className="pop_align">
                        <div className="form-group">
                           <input type="submit" name="save" className="btn btn-sl-form"  value="Submit" />
                        </div>
                     </div>
                     <div className="success_message1 pop_align"></div>
                  </form>
               </div>
            </div>
         </div>
      </div>
	  
	  
		<div id="ganesh" className="modal fade" role="dialog">
			<div className="modal-dialog modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
						<h4 className="modal-title pop_align">Site Visit Pickup & Drop</h4>
					</div>
					<div className="modal-body">
					  
					<form  method="post" id="Thane">
						<div className="form-group">
							<div className="input-group"> 
								<span className="input-group-addon"><i className="fa fa-user"></i></span>
								<input className="form-control" name="fname" id="fname1" placeholder="Name *" required />
							</div>
						</div>
						 <div className="form-group">
							<div className="input-group"> 
								<span className="input-group-addon"><i className="fa fa-phone-square" ></i></span>
										 <input type="text" className="form-control" name="mobile" id="mobile1" placeholder="Mobile *" required />
							</div>
						</div>
						<div className="form-group">
							<div className="input-group"> 
								<span className="input-group-addon"><i className="fa fa-calendar "></i></span>
								<input type="date" className="form-control" name="date" id="date1" placeholder="Date *" required />
				   
							</div>
						</div>
						<div className="form-group">
							<div className="input-group"> 
								<span className="input-group-addon"><i className="fa fa-map-marker"></i></span>
								<textarea className="form-control" name="location" id="location2" placeholder="Location *" required></textarea>
							</div>
						</div>
					  <div className="pop_align">
					 <div className="form-group">
						<input type="submit" className="btn btn-sl-form" value="Submit"/>
					 </div>
					</div>
					<div className="success_offerspop pop_align"></div>
				</form>
					</div>
				</div>
			</div>
		</div>


      <div id="myModals" className="modal fade">
         <div className="modal-dialog">
            <div className="modal-content">
               <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                  <h4 className="modal-title pop_align">Get in touch for Kalpataru Parkcity Thane </h4>
               </div>
               <div className="modal-body">
                  <form  method="post" id="signupForm2">
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-user"></i></span>
                           <input className="form-control" name="fname" id="fnameb" placeholder="Name" required />
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                           <input type="email" className="form-control" name="email" id="emailb" placeholder="Email" required />
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group">
                           <span className="input-group-addon"><i className="fa fa-phone-square" ></i></span>
                           <div className="col-lg-3">
                              <div className="row">
                                 <select name="code" id="codes" className="form-control" >
                                    <option  value="">Select Country</option>
                                    <option value="+91">India</option>
                                    <option value="+971">United Arab Emirates</option>
                                    <option value="+1">USA</option>
                                    <option value="+1">Canada</option>
                                    <option value="+44">United Kingdom</option>
                                    <option value="+61">Australia</option>
                                    <option value="+65">Singapore</option>
                                    <option value="+974">Qatar</option>
                                    <option value="+968">Oman</option>
                                    <option value="+64">New Zealand</option>
                                    <option value="+60">Malaysia</option>
                                    <option value="+852">Hong Kong</option>
                                    <option value="+0">Others</option>
                                 </select>
                              </div>
                           </div>
                           <div className="col-lg-9">
                              <div className="row">
                                 <input type="text" className="form-control" name="mobile" id="mobileb" placeholder="Mobile" />
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-comment"></i></span>
                           <textarea className="form-control" name="mesg" id="mesgb" placeholder="Massage" rows="3"></textarea>
                        </div>
                     </div>
                     <div className="pop_align">
                        <div className="form-group">
                           <input type="submit" className="btn btn-sl-form" value="Submit" />
                        </div>
                     </div>
                     <div className="success_message2 pop_align"></div>
                  </form>
               </div>
            </div>
         </div>
      </div>

      <div id="feedback">
         <div id="feedback-form" className="col-xs-4 col-md-4 panel panel-default displaynone">
            <h3>Instant Call Back</h3>
            <form  method="post" id="signupForm3">
               <div className="form-group">
                  <div className="input-group"> 
                     <span className="input-group-addon"><i className="fa fa-user"></i></span>
                     <input className="form-control" name="fname" id="fnamec" placeholder="Name" />
                  </div>
               </div>
               <div className="form-group">
                  <div className="input-group"> 
                     <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                     <input type="email" className="form-control" name="email" id="emailc" placeholder="Email" />
                  </div>
               </div>
               <div className="form-group">
                  <div className="input-group"> 
                     <span className="input-group-addon"><i className="fa fa-phone-square" ></i></span>
                     <input type="text" className="form-control" name="mobile" id="mobilec" placeholder="Mobile" />
                  </div>
               </div>
               <div className="pop_align">
                  <div className="form-grop">
                     <input type="submit" className="btn btn-sl-form" value="Submit"/>
                  </div>
               </div>
               <div className="success_message3 float_left"></div>
            </form>
         </div>
         <div id="feedback-tab">Instant Call Back</div>
      </div>
    
      <nav id="mainNav" className="navbar navbar-default navbar-fixed-top" >
         <div className="container">
            <div className="navbar-header">
	 
               <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
               <span className="sr-only">Toggle navigation</span> Menu <i className="fa fa-bars"></i>
               </button>
			    
               <a className="navbar-brand page-scroll" href="#page-top">
               <img src="img/logo.png" width="113" className="img-responsive " alt="Kalpataru Parkcity" title="Kalpataru Parkcity" />
               </a>
            </div>
            <div className="cell">
               <a href="tel:+919130568016">
                  <div className="col-md-2 cell_phone"><i className="fa fa-phone"></i>&ensp;+91 91305 68016</div>
               </a>
            </div>
            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
               <ul className="nav navbar-nav navbar-right">
                  <li><a className="page-scroll" href="#page-top">Home</a></li>
                  <li><a className="page-scroll" href="#about">About</a></li>
				  <li><a className="page-scroll" href="#rate">Configuration</a></li>
                  <li><a className="page-scroll" href="#amenities">Amenities</a></li>
                  <li><a className="page-scroll" href="#plans">Plan</a></li>
                  <li><a className="page-scroll" href="#location">Location</a></li>
                  <li><a className="page-scroll" href="#contact">Contact</a></li>
				  <li><a className="page-scroll" href="#" data-toggle="modal" data-target="#myModal"><b><i className="fa fa-download animated"></i> E-BROCHURE</b></a></li>
               </ul>
            </div>
         </div>
      </nav>
    
 
 
		 <header className="container-fluid md-3form">
	     <div className="row">
	     
			<div className="col-md-9 col-md-91">
				<div className="row">
		
		 
 
				 <div id="myCarousel" className="carousel slide " data-ride="carousel">
					 <ol className="carousel-indicators">
						<li data-target="#myCarousel" data-slide-to="0" className="active"></li>
						<li data-target="#myCarousel" data-slide-to="1"></li>
						<li data-target="#myCarousel" data-slide-to="2"></li>
						 
					  </ol>
						<div className="carousel-inner">
							<div className="item active">
								<img className="d-banner1" style={{width:"100%"}} src="img/02.jpg" alt="Kalpataru Parkcity"/>
							</div>
							<div className="item">
								<img className="d-banner1" style={{width:"100%"}} src="img/02.jpg" alt="Kalpataru Parkcity"/>
							</div>
							 
						</div>
						
						
					
					<a className="left carousel-control" href="#myCarousel" data-slide="prev">
					<i className="fa fa-arrow-left slicon-left"></i><span className="sr-only">Previous</span></a>
					<a className="right carousel-control" href="#myCarousel" data-slide="next"><i className="fa fa-arrow-right slicon-right"></i><span className="sr-only">Next</span></a>
					</div>
					</div>
					
	<div id="hero-content" className="text-align-center">
			<p className="top-patch">Booking Open</p>
			<div className="project-info">
				<p className="project-name">Kalpataru Parkcity</p>
				<p className="project-extraname">Kalpataru Parkcity</p>
				<p className="project-location">At Thane</p>
				<p className="project-developer">By Kalpataru Group</p>
			</div>
			<div className="project-addon-info">
				<p>→ Land Parcel: <b>108 Acres</b></p>
				<p>→ Possession: <b>Within 3 years (2024)</b></p>
				<p>→ Near <b>Palaspe Phata</b></p>
			</div>
			<div className="project-booking-info">
				<div className="project-booking-info-points" >No Floor Rise<p></p></div>
				<p className="project-booking-amount">Luxurious 1,2,3 & 4 BHK <br/>
USP Grand Central Park View</p>
 
			</div>
			<div className="project-configuration-details">
			 
				<p>2 & 3 BHK With Deck Starting</p>
			</div>
			<div className="project-price">
				<p>Starting Price 1.15Cr *</p>
			</div>
			<div className="project-enquiry">
			   <a href="#" data-toggle="modal" className="btn btn-price" data-target="#myModals"><b><i class="fa fa-car faa-tada animated"></i> Book Site Visit</b></a>
			</div>
			<div className="project-rera">
				<p>RERA No: P51700020264 </p>
			</div>
	   </div>
					
					
				</div> 

				<div className="col-md-3 col-md-31 sl">
				<div className="row">
				  <div className="sliderform1">
				 				 
				 <h4>Register here for Best Offers</h4>
                     <p className="high_label ">
					 <span className="animated bounceIn infinite high_label_span">2 Bhk With Deck & 3 Bhk With Deck At Rs. 1.15Cr All Inc</span></p>
					 
					 
                     <form method="post" id="sliderform">
                        <div className="form-group">
                           <div className="input-group"> 
                              <span className="input-group-addon"><i className="fa fa-user"></i></span>
                              <input className="form-control" name="fname" id="fnamef" placeholder="Name" required />
                           </div>
                        </div>
                        <div className="form-group">
                           <div className="input-group"> 
                              <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                              <input type="email" className="form-control" name="email" id="emailf" placeholder="Email" required />
                           </div>
                        </div>
						<div className="form-group">
                           <div className="input-group"> 
                              <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                              <input type="text"  className="form-control" name="mobile" id="mobilef" placeholder="Mobile" />
                           </div>
                        </div>
                       
                      
                           <div className="form-group pop_align">
                              <input type="submit" className="btn btn-sl-form" value="Submit" />
                           </div>
                       
                        <div className="success_message4 pop_align"></div>
                     </form> 
		
 
					<div className="form-title">
						<ul>
						   
							<li>Eastern Express Highway is just 11 minutes away</li>
							<li> At the distance of 6 minutes is the Ghodbunder Road</li>
							<li>Jupiter Hospital is at the distance 0f 16 minutes</li>
							<li> Drive to Kala Bhavan in just 11 minutes</li>
							<li> At the distance of 11 minutes is the C.P. Goenka International School</li>
							 			
						</ul>		
													
					</div>
					
				  </div>
				
				</div> 
				</div> 
	   </div>
    </header>
	
      <section className="contact_div form_mob">
         <div className="container ">
            <div className="row">
               <div className="col-md-8 col-md-offset-2 col-sm-9 col-sm-offset-1 text-center" >
                  <h4 className="form_mob_title">Pre-Register here for Best Offers</h4>
				   
                  
                   <form method="post" id="formmobile">
                <div className="form-group">
                    <input type="text" className="form-control form_mob_field" name="fname" id="fnamemid" placeholder="Name" required />
                </div>
                <div className="form-group">
                    <input type="email" className="form-control form_mob_field" name="email" id="emailmid" placeholder="Email" required />
                </div>
                <div className="form-group">

                    <input type="text" className="form-control form_mob_field" name="mobile" id="mobilemid" placeholder="Mobile" required />
                </div>
 
				<div className="col-md-3 col-md-offset-4">
					<div className="form-group">
						<input type="submit" className="btn btn-sl-form"  value="Submit" />
					</div>
				</div>
				<div className="success_mobile pop_align"></div>
			</form>
                  
               </div>
            </div>
         </div>
      </section>
			
	
      <section className="bg-primary1" id="about">
         <div className="container">
            <div className="row">
                
                  <h1 className="section-heading sectionheading1 text-center">Kalpataru Parkcity</h1>
                  <hr className="light1"/> 
					<div className="col-lg-8 text-center">
				 		<p><b>Pre-Launching New Project Kalpataru Parkcity at Thane. </b></p>
						
						<p>Kalpataru Parkcity is growing at a fast pace and launching more phase. The pre-launch of Phase III, Launch Code Starlight, the largest phase in Kalpataru Parkcity with 10 towers has already been annonced. Each tower has been designed with a distinct elevation charactor to avoid a well effect</p>
						
						<p><a href="https://todayaamod.pre-launch.co/" class="url">Kalpataru Parkcity</a> is a new Residential project at Thane, Navi Mumbai which offers exclusive 1BHK & 2BHK residences. Its an emerging location with residential project in Thane. It is the most premium area of Thane near Malls, School and Hospitals. Its location is very close to Thane station and major transit routes & proposed corporate campuses. </p>
						
						<p>Like all projects of Today Global Developers we emphasize on elements of Height, Light and Air. Every Space is built to maximise Cross Ventilation, Natural light and higher floor to floor heights.</p>
						
						<p>The external amenities at this project include Swimming Pool, Zen Yoga & Meditation Center, Multipurpose Hall, Gymnasium, Toddler play area, Senior Citizen Corner, Jogging Track etc.</p>
						
						<div className="form-group"><input type="submit" data-toggle="modal" data-target="#ganesh" className="btn btn-sl-form" value="Pick Up & Drop Facility" /></div>
						 
					</div>
				  
					  <div className="col-lg-4 text-center">
						<img src="img/kalpat.jpg" className="aboutimg img-responsive text-center" alt="Kalpataru Parkcity Thane"  title="Kalpataru Parkcity Thane"/>
					  </div>
            </div>
         </div>
      </section>
    
	  <section id="rate" className="rate">
         <div className="container rate-sub1">
            <div className="row">
               <div className="col-lg-12 text-center">
                  <h2 className="section-heading-rate sectionheading2">Configuration</h2>
                  <hr className="color"/>
               </div>
            </div>
            <div className="col-lg-8 col-sm-8">
               <div className="row">
                  <table className="table table" >
					<thead >
						<tr>
							<th className="table_th">Configuration</th>
							<th className="table_th">Carpet Area</th>
							<th className="table_th">Price</th>
							 
						</tr>
					</thead>
					<tbody className="table_tbody">
						<tr>
							<td className="bg-grey-table1">1 BHK</td>
							<td className="bg-grey-table1">598 Sq.ft.</td>
							<td className="bg-grey-table2">
							<a className="price-click" href="#" data-toggle="modal" data-value="2 BHK" data-target="#myModals">1.10 All Inc.</a>
							</td>
							 
						</tr>
						 
						<tr>
							<td className="bg-grey-table1">3 BHK</td>
							<td className="bg-grey-table1">944 Sq.ft.</td>
							<td className="bg-grey-table2">
							<a className="price-click" href="#" data-toggle="modal" data-value="2 BHK" data-target="#myModals">1.75 All Inc.</a>
							</td>
							
						</tr>
						
						<tr>
							<td className="bg-grey-table1">3 BHK</td>
							<td className="bg-grey-table1">1150 Sq.ft.</td>
							<td className="bg-grey-table2">
							<a className="price-click" href="#" data-toggle="modal" data-value="2 BHK" data-target="#myModals"> 2.20 All Inc.</a>
							</td>
							 
						</tr>
						
						<tr>
							<td className="bg-grey-table1">4 BHK</td>
							<td className="bg-grey-table1">1753 Sq.ft.</td>
							<td className="bg-grey-table2">
							<a className="price-click" href="#" data-toggle="modal" data-value="2 BHK" data-target="#myModals">3.99 Cr Onwards.</a>
							</td>
							 
						</tr>

						 
						 

					</tbody>
				</table>  
               </div>
               <h3 className="pop_align1">For booking process please call us now: +91 9130568016</h3>
            </div>
			
			<div className="col-lg-4 col-sm-4">
               <div className="container3 ">
                  <a href="#" data-toggle="modal" className="btn btn-costing" data-target="#myModals"><img src="img/costing.jpg" className="aboutimg img-responsive imaged" alt="Kalpataru Parkcity Thane"  title="Kalpataru Parkcity Thane"/>
				  
				  <div className="overlay3">
					<div className="text">Enquire Now</div>
				  </div></a>
               </div>
               <h3 className="pop_align1">Costing Details</h3>
			   
            </div>
		 
         </div>
      </section>
    
	  
      <section id="amenities">
         <div className="container amenities-sub1">
            <div className="row">
               <div className="col-lg-12 text-center">
                  <h2 className="section-heading sectionheading1">Amenities</h2>
                  <hr className="primary"/>
               </div>
            </div>
			
			
			<div className="row1">
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/clubhouse.png" alt="" height="75"/>
								  <p> Club House </p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/running.png" alt="" height="75"/>
								  <p> Jogging Track</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/dumble.png" alt="" height="75"/>
								  <p> Gymnasium </p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/squash.png" alt="" height="75"/>
								  <p> Squash Court </p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/pool.png" alt="" height="75"/>
								  <p> Swimming Pool</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/hall.png" alt="" height="75"/>
								  <p> Multipurpose Hall</p>
							</div>
						</div>

						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/cafe.png" alt="" height="75"/>
								  <p> Cafe</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/gamepad.png" alt="" height="75"/>
								  <p> Indoor Game Room</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/medtation.png" alt="" height="75"/>
								  <p>Yoga Lawn</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/reflexology.png" alt="" height="75"/>
								  <p> Reflexology Pool</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/kids-pay.png" alt="" height="75"/>
								  <p> Kid's Play Area</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/senior.png" alt="" height="75"/>
								  <p> Senior Citizen's Area</p>
							</div>
						</div>
						
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/ami.png" alt="" height="75"/>
								  <p> Amphith eatre</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/lib.png" alt="" height="75"/>
								  <p> E-Library</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/park.png" alt="" height="75"/>
								  <p> Central Greens</p>
							</div>
						</div>
						<div className="col-md-2 col-xs-6">
							<div className="ame">
								<img src="img/amenities/cctv.png" alt="" height="75"/>
								  <p> Security</p>
							</div>
						</div>
						 
					</div>  
 
	   
         </div>
      </section>


      <section id="plans"  className="bg-primary">
         <div className="container">
            <div className="row">
               <div className="col-lg-12 text-center">
                  <h2 className="section-heading sectionheading1">Kalpataru Parkcity Floor Plans </h2>
                  <hr className="primary"/>
               </div>
            </div>
         </div>
         <div className="container">
            <div className="row no-gutter  wow fadeInUp">
               <div className="col-lg-10 col-sm-10 col-xs-12 col-md-offset-2">
				   <div className="col-md-4 col-xs-12">
						<h3 style={{textAlign:"center"}}>Layout Map</h3>
					  <a href="#" data-toggle="modal" data-value="2 BHK" data-target="#myModals" >
						 <img src="img/floorplan/layout.jpg"  className="img-responsive" alt="Kalpataru Parkcity" title="Kalpataru Parkcity"/>
						  
					  </a>
				   </div>
				   <div className="col-md-2 col-xs-12">
				   </div>
				   <div className="col-md-4 col-xs-12">
					<h3 style={{textAlign:"center"}}>Floor Plans</h3>
					  <a href="#" data-toggle="modal" data-value="2 BHK" data-target="#myModals" >
						 <img src="img/floorplan/floorplan-hinde.jpg" style={{width:"100%"}} className="img-responsive" alt="Kalpataru Parkcity" title="Kalpataru Parkcity"/>
						  
					  </a>
				   </div>
               </div>
               			   
			   
            </div>
         </div>
      </section>
    
      
      <section id="location">
         <div className="container">
            <div className="row">
               <div className="col-lg-12 text-center">
                  <h2 className="section-heading sectionheading1">Location</h2>
                  <hr className="primary"/>
               </div>
            </div>
         </div>
         <div className="container">
            <div className="row">
				<div className="col-lg-7 col-sm-7 pop_align">
					<div className="col-lg-12 col-sm-12">	
						 <a href="#myModals">
						 <img src="img/location.jpg" alt="Location Kalpataru Parkcity" title="Kalpataru Parkcity" data-toggle="modal" data-target="#myModals" className="img-responsive pop_align" /><br/>
						 </a>
					</div>
			    </div> 
				<div className="col-sm-5">
					<div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
						<div className="panel panel-default active">
							<div className="panel-heading" role="tab" id="headingOne">
								<h4 className="panel-title">
									<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
										<i className="more-less fa fa-plus" aria-hidden="true"></i>
										Current
									</a>
								</h4>
							</div>
							<div id="collapseOne" className="panel-collapse" role="tabpanel" aria-labelledby="headingOne">
								<div className="panel-body">
									  <ul>
										<li>LBS Marg - 5.2KM</li>
										<li>Eastern Express Highway - 2.2KM</li>
										<li>Ghodbunder Road  - 1.5KM</li>
										<li>Navi Mumbai 13KM</li>
										<li>Bhiwandi-Kalyan JN - 16.6KM</li>
										<li>International Airport - 23KM</li>
										 
									  </ul>
								</div>
							</div>
						</div>
												
						<div className="panel panel-default">
							<div className="panel-heading" role="tab" id="headingTwo">
								<h4 className="panel-title">
									<a className="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
										<i className="more-less fa fa-plus" aria-hidden="true"></i>
										Scools
									</a>
								</h4>
							</div>
							<div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
								<div className="panel-body">
									<ul>
										<li>St. Johns - 5.1KM </li>
										<li>Vasant Vihar - 3.9KM</li>
										<li>Holy Cross - 3.4KM</li>
										<li>Billabong - 9.1KM</li>
										<li>SMT. Sulochanadevi SInghania - 4.1KM</li>
										<li>CP Goenka International - 2.4KM</li>
									  </ul>
								</div>
							</div>
						</div>

						<div className="panel panel-default">
							<div className="panel-heading" role="tab" id="headingThree">
								<h4 className="panel-title">
									<a className="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
										<i className="more-less fa fa-plus" aria-hidden="true"></i>
										EDUCATIONAL INSTITUTIONS
									</a>
								</h4>
							</div>
							<div id="collapseThree" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
								<div className="panel-body">
									<ul>
										<li>Dr Pillai Global Academy – 10 mins</li>
										<li>MGM College of Medical & Engineering – 12 mins</li>
										<li>NIFT – 20 mins</li>
										<li>Amity University – 22 mins</li>
									 </ul>
								</div>
							</div>
						</div>
						<div className="panel panel-default">
							<div className="panel-heading" role="tab" id="headingfour">
								<h4 className="panel-title">
									<a className="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
										<i className="more-less fa fa-plus" aria-hidden="true"></i>
										RETAIL
 
									</a>
								</h4>
							</div>
							<div id="collapsefour" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingfour">
								<div className="panel-body">
									<ul>
										<li>Panvel Market Yard – 4 mins</li>
										<li>Orion Mall – 7 mins</li>
										<li>D-Mart – 10 mins</li>
									  </ul>
								</div>
							</div>
						</div>

						
						
						</div>
				</div>

			   
            </div>
			
         </div>
      </section>

      <aside className="bg-dark">
         <div className="container text-center">
            <div className="call-to-action">
               <h3>For more Information call : +91 91305 68016</h3>
               <a href="#myModal" data-toggle="modal" data-target="#myModal" className="btn btn-default btn-xl sr-button">Download Brochure!</a>
            </div>
         </div>
      </aside>

      
	  
	 

 <section id="contact"  >
         <div className="container">
            <div className="row">
				<div className="col-lg-6 text-center">
                  <h3 className="section-heading">About Developer</h3>
                  <hr className="light"/>
					
					<p>With experience of 4 decades, Kalpataru Group reflects excellence of developing and building premium residential towers, gated communities, townships and office properties. Owing 100+ awards testimony to their legacy, with 105 landmark projects Kalpataru made 17,500 Happy Families.</p>
               </div>
			   
               <div className="col-lg-6 text-center">
                  <h3 className="section-heading">Lets Get In Touch! </h3>
                  <hr className="primary"/>
                  <form method="post" id="contactinq">
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-user"></i></span>
                           <input className="form-control" name="fname" id="fname" placeholder="Name" required/>
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                           <input type="email" className="form-control" name="email" id="email" placeholder="Email" required/>
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-phone-square" ></i></span>
                           <input type="text" className="form-control" name="mobile" id="mobile" placeholder="Mobile" required/>
                        </div>
                     </div>
                     <div className="form-group">
                        <div className="input-group"> 
                           <span className="input-group-addon"><i className="fa fa-comment"></i></span>
                           <textarea className="form-control" name="mesg" id="mesg" placeholder="Massage" rows="4"></textarea>
                        </div>
                     </div>
                     <div className="pop_align">
                        <div className="form-group">
                           <input type="submit" className="btn btn-sl-form" value="Submit"/>
                        </div>
                     </div>
                     <div className="success_message pop_align"></div>
                     <br/>
                  </form>
               </div>
               
			   <div className="col-lg-12 text-center">
                  <i className="fa fa-phone fa-3x sr-contact"></i>
                  <h3>+91 9130568016</h3>
               </div>
			   
			   
            </div>
         </div>
      </section>

      <div className="bg-dark">
         <div className="container text-center">
            <div>
               
			   <div className="reranumber"><b>Project - MahaRERA No.:</b> P51700020264</div>
               <div className="disclaimer"><b>Disclaimer:</b>  This Website Is Managed By Kalpataru Parkcity Thane, Navi Mumbai Authorised Media Partner.</div>
          <br/><br/>
            </div>
         </div>
      </div>

      <div className="whatsapp-area">
         <div className="chat-button-area zoomOut">
            <button type="button" id="whatsapp-btn"  className="whatsapp-btn"> 
            <a href="https://wa.me/919082164514?text=Hi.. I am interested in Kalpataru Parkcity Project. Please help me with the details. Thanks!" target="_blank">
            <span className="icon-whatsapp"></span> <i className="fa fa-whatsapp"></i>
            </a>
            </button> 
            <div className="circle-animation">
            </div>
         </div>
      </div>
    
    </div>
  );
}

export default App;
